import React from 'react';
import {Platform} from 'react-native';

import MetricSection from '/component/partial/MetricSection';
import {MetricsSection} from '/constant/TestIDs';

import {useBonusesSection} from './BonusesSection.hook';
import {BonusesSectionProps} from './BonusesSection.types';

export const BonusesSection: React.FC<BonusesSectionProps> = ({
  clientAcquisitionBonus = 0,
  eligibleForAccelBonusCount = 0,
  threeToFourCSBPClientCount = 0,
  fiveToSixCSBPClientCount = 0,
  sevenToNineCSBPClientCount = 0,
  oneToTwoCSBPClientCount = 0,
  onShowReport = () => {},
  quickStartBonus = 0,
  onShowInfoPopover = () => {},
  eligibleClientSupportBonusPlusCount = 0,
  showCSBPlus = false,
  showIncentiveTrip = false,
  eligibleForIncentiveTrip = 0,
  showEligibleQSB = false,
  achievedCSBPTierOneCount = 0,
  achievedCSBPTierTwoCount = 0,
  eligibleForQsbCount = 0,
  showCsbPlusInsightsFiltering = false,
  NewCoachesAquiringClients = false,
  rankUp = 0,
  earnedClientSupportBonusPlusCount = 0,
  earnedAccelBonusCount = 0,
}) => {
  const containerStyle = Platform.OS === 'web' ? {marginBottom: 8} : undefined;
  const {listItems, onInfoPress, onItemPress, ts} = useBonusesSection({
    clientAcquisitionBonus,
    eligibleForAccelBonusCount,
    oneToTwoCSBPClientCount,
    threeToFourCSBPClientCount,
    fiveToSixCSBPClientCount,
    sevenToNineCSBPClientCount,
    eligibleForIncentiveTrip,
    onShowReport,
    quickStartBonus,
    onShowInfoPopover,
    eligibleClientSupportBonusPlusCount,
    achievedCSBPTierOneCount,
    achievedCSBPTierTwoCount,
    eligibleForQsbCount,
    showCSBPlus,
    showIncentiveTrip,
    showCsbPlusInsightsFiltering,
    NewCoachesAquiringClients,
    showEligibleQSB,
    rankUp,
    earnedClientSupportBonusPlusCount,
    earnedAccelBonusCount,
  });

  return (
    <MetricSection
      analyticsTitle="Bonuses"
      infoAccessibilityLabel={ts(
        'accessibilityLabel',
        'Bonuses Section Information',
      )}
      testID={MetricsSection.metricSectionBonuses}
      title={ts('heading', 'Coaches Acquiring Clients')}
      listItems={listItems}
      onInfoPress={onInfoPress}
      onItemPress={onItemPress}
      containerStyle={containerStyle}
    />
  );
};

export default BonusesSection;
